// Utility function to compute the GCD of two numbers
const gcd = (a, b) => {
  while (b) {
    [a, b] = [b, a % b];
  }
  return a;
};

// Function to convert decimal odds to fractional odds
export const decimalToFractional = (decimal) => {
  const numerator = Math.round((decimal - 1) * 10000);
  const denominator = 10000;
  const commonDivisor = gcd(numerator, denominator);
  return `${numerator / commonDivisor}/${denominator / commonDivisor}`;
};

// Function to convert fractional odds to decimal odds
export const fractionalToDecimal = (fractional) => {
  const [numerator, denominator] = fractional.split('/').map(Number);
  return (numerator / denominator) + 1;
};

// Function to convert decimal odds to American odds
export const decimalToAmerican = (decimal) => {
  return decimal >= 2 ? Math.round((decimal - 1) * 100) : Math.round(-100 / (decimal - 1));
};

// Function to convert American odds to decimal odds
export const americanToDecimal = (american) => {
  return american > 0 ? (american / 100) + 1 : (100 / -american) + 1;
};
